import React, { useState, useRef, useEffect } from 'react';
import './Login.scss';
import BixButton from '$/components/global/bixButton';
import Error from '$/components/global/error/Error';
import { AppState } from '$/store';
import classnames from 'classnames';
import { connect } from 'react-redux';

interface IProps {
  emailPlaceholder: string;
  passwordPlaceholder: string;
  isLoading: boolean;
  email: string;
  password: string;
  onEmailChange: React.ChangeEventHandler;
  onPasswordChange: React.ChangeEventHandler;
  onSubmit: React.FormEventHandler;
  errorText?: string;
  isRefreshModalOpen: boolean;
}

const LoginForm: React.FC<IProps> = props => {
  const {
    onSubmit,
    isLoading,
    email,
    password,
    onEmailChange,
    onPasswordChange,
    errorText,
    emailPlaceholder,
    passwordPlaceholder,
    isRefreshModalOpen,
  } = props;

  const [isValid, setIsValid] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    if (formRef === null || formRef.current === null || !formRef) {
      return;
    }
    setIsValid((formRef.current as HTMLFormElement).checkValidity());
  }, [email, password, formRef]);

  return (
    //
    <form
      className={classnames('login_form', { login_form_modal: isRefreshModalOpen })}
      onSubmit={onSubmit}
      ref={formRef}>
      <input
        type="email"
        placeholder={emailPlaceholder}
        name={emailPlaceholder}
        value={email}
        onChange={onEmailChange}
        required
      />
      <input
        type="password"
        placeholder={passwordPlaceholder}
        name={passwordPlaceholder}
        value={password}
        onChange={onPasswordChange}
        required
      />
      <BixButton type="submit" disabled={isLoading || !isValid} useLoading isLoading={isLoading}>
        Login
      </BixButton>
      {errorText && <Error>{errorText}</Error>}
    </form>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    isRefreshModalOpen: state.loginState.isRefreshModalOpen,
  };
};

export default connect(mapStateToProps)(LoginForm);
